import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <FeaturesSection />
        <RankingSection />
        <CarouselSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <CommentsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}